// xgen-init.js
(() => {
  const MIGRATION_VERSION = 'v1';
  const COOKIE_RESET_VERSION = '1';
  const CONFIG_SIGNATURE_STORAGE_KEY =
    `xgen_config_signature_st_${MIGRATION_VERSION}`;
  const COOKIE_RESET_STORAGE_KEY =
    `xgen_cookie_reset_${MIGRATION_VERSION}`;
  const config = {
    key: '8b036eb9db86e4432a36d627366fd4f3',
    secret: 'b27791132df6703026b5b8092289303888aa4f71fd724391cc0453e88e89c46b912d01926639dca46dd86151b1c6d90ca572d0afdb095f43041d7485506fa366',
    clientId: '4d998316ec1231ad1a791585db0fe1f0',
    trackerId: 'c586d282d0cb4a50953ef689bc0495cf',
    locale: 'en_US',
  };

  const XGEN_COOKIE_NAMES = ['xgen_user', 'xgen_session', 'xgen_token'];

  const getConfigSignature = () => {
    const raw = [config.key, config.clientId, config.trackerId, config.locale].join('|');
    let hash = 2166136261;
    for (let i = 0; i < raw.length; i += 1) {
      hash ^= raw.charCodeAt(i);
      hash = Math.imul(hash, 16777619);
    }
    return `${MIGRATION_VERSION}_${(hash >>> 0).toString(16).padStart(8, '0')}`;
  };

  const getStoredConfigSignature = () => {
    try {
      return (
        localStorage.getItem(CONFIG_SIGNATURE_STORAGE_KEY) ||
        sessionStorage.getItem(CONFIG_SIGNATURE_STORAGE_KEY)
      );
    } catch {
      return null;
    }
  };

  const setStoredConfigSignature = (signature) => {
    try {
      localStorage.setItem(CONFIG_SIGNATURE_STORAGE_KEY, signature);
    } catch {
      try {
        sessionStorage.setItem(CONFIG_SIGNATURE_STORAGE_KEY, signature);
      } catch { /* ignore */ }
    }
  };

  const getStoredCookieResetVersion = () => {
    try {
      return (
        localStorage.getItem(COOKIE_RESET_STORAGE_KEY) ||
        sessionStorage.getItem(COOKIE_RESET_STORAGE_KEY)
      );
    } catch {
      return null;
    }
  };

  const setStoredCookieResetVersion = (version) => {
    try {
      localStorage.setItem(COOKIE_RESET_STORAGE_KEY, version);
    } catch {
      try {
        sessionStorage.setItem(COOKIE_RESET_STORAGE_KEY, version);
      } catch { /* ignore */ }
    }
  };

  const expireCookie = (name, path, domain) => {
    const base = `${name}=; Max-Age=0; path=${path}`;
    const same = '; SameSite=Lax';
    const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : '';
    if (domain) {
      document.cookie = `${base}; domain=${domain}${same}${secure}`;
    } else {
      document.cookie = `${base}${same}${secure}`;
    }
  };

  const clearLegacyXgenCookies = () => {
    const path = '/';
    const host = typeof location !== 'undefined' ? location.hostname : '';
    const parts = host.split('.').filter(Boolean);
    const parent = parts.length > 1 ? `.${parts.slice(-2).join('.')}` : '';
    const domains = new Set();
    if (host) {
      domains.add(host);
      if (parent) domains.add(parent);
      domains.add(`.${host}`);
    }
    for (const name of XGEN_COOKIE_NAMES) {
      expireCookie(name, path, undefined);
      for (const domain of domains) {
        expireCookie(name, path, domain);
      }
    }
  };

  // One-time cookie reset for all returning users when cookieResetVersion bumps.
  const syncCookiesWithCurrentConfig = () => {
    const currentSignature = getConfigSignature();
    const storedSignature = getStoredConfigSignature();
    const storedResetVersion = getStoredCookieResetVersion();
    const migrationResetNeeded = storedResetVersion !== COOKIE_RESET_VERSION;
    const configChanged = storedSignature && storedSignature !== currentSignature;

    if (migrationResetNeeded || configChanged) {
      console.log(
        migrationResetNeeded
          ? '[XGEN] Cookie reset version changed, clearing XGen cookies for new customer.'
          : '[XGEN] Config changed, clearing XGen cookies.'
      );
      clearLegacyXgenCookies();
    }

    setStoredCookieResetVersion(COOKIE_RESET_VERSION);
    setStoredConfigSignature(currentSignature);
  };

  syncCookiesWithCurrentConfig();

  const initSdk = () => {
    if (!window.XGenSdkCore?.XGenClient) {
      setTimeout(initSdk, 50);
      return;
    }

    try {
      const { XGenClient } = window.XGenSdkCore;
      window.xgenClient = new XGenClient(config);
      document.dispatchEvent(new Event('xgen-ready'));
    } catch (err) {
      console.error('Init Error:', err);
    }
  };

  initSdk();
})();

// // xgen-init.js
// (() => {
//   const MIGRATION_VERSION = 'v1';
//   const CONFIG_SIGNATURE_STORAGE_KEY = `xgen_config_signature_st_${MIGRATION_VERSION}`;

//   const config = {
//     key: '8b036eb9db86e4432a36d627366fd4f3',
//     secret: 'b27791132df6703026b5b8092289303888aa4f71fd724391cc0453e88e89c46b912d01926639dca46dd86151b1c6d90ca572d0afdb095f43041d7485506fa366',
//     clientId: '4d998316ec1231ad1a791585db0fe1f0',
//     trackerId: 'c586d282d0cb4a50953ef689bc0495cf',
//     locale: 'en_US',
//   };

//   const XGEN_COOKIE_NAMES = ['xgen_user', 'xgen_session', 'xgen_token'];

//   const getConfigSignature = () => {
//     const raw = [config.key, config.clientId, config.trackerId, config.locale].join('|');
//     let hash = 2166136261;
//     for (let i = 0; i < raw.length; i += 1) {
//       hash ^= raw.charCodeAt(i);
//       hash = Math.imul(hash, 16777619);
//     }
//     return `${MIGRATION_VERSION}_${(hash >>> 0).toString(16).padStart(8, '0')}`;
//   };

//   const getStoredConfigSignature = () => {
//     try {
//       return (
//         localStorage.getItem(CONFIG_SIGNATURE_STORAGE_KEY) ||
//         sessionStorage.getItem(CONFIG_SIGNATURE_STORAGE_KEY)
//       );
//     } catch {
//       return null;
//     }
//   };

//   const setStoredConfigSignature = (signature) => {
//     try {
//       localStorage.setItem(CONFIG_SIGNATURE_STORAGE_KEY, signature);
//     } catch {
//       try {
//         sessionStorage.setItem(CONFIG_SIGNATURE_STORAGE_KEY, signature);
//       } catch { /* ignore */ }
//     }
//   };

//   const expireCookie = (name, path, domain) => {
//     const base = `${name}=; Max-Age=0; path=${path}`;
//     const same = '; SameSite=Lax';
//     const secure = typeof location !== 'undefined' && location.protocol === 'https:' ? '; Secure' : '';
//     if (domain) {
//       document.cookie = `${base}; domain=${domain}${same}${secure}`;
//     } else {
//       document.cookie = `${base}${same}${secure}`;
//     }
//   };

//   const clearLegacyXgenCookies = () => {
//     const path = '/';
//     const host = typeof location !== 'undefined' ? location.hostname : '';
//     const parts = host.split('.').filter(Boolean);
//     const parent = parts.length > 1 ? `.${parts.slice(-2).join('.')}` : '';
//     const domains = new Set();
//     if (host) {
//       domains.add(host);
//       if (parent) domains.add(parent);
//       domains.add(`.${host}`);
//     }
//     for (const name of XGEN_COOKIE_NAMES) {
//       expireCookie(name, path, undefined);
//       for (const domain of domains) {
//         expireCookie(name, path, domain);
//       }
//     }
//   };

//     // Sync cookies with current config
//   const syncCookiesWithCurrentConfig = () => {
//       const currentSignature = getConfigSignature();
//       const storedSignature = getStoredConfigSignature();
//       const hasLegacyCookies = XGEN_COOKIE_NAMES.some((name) =>
//         document.cookie
//           .split(';')
//           .some((cookie) => cookie.trim().startsWith(`${name}=`))
//       );
//     if (!storedSignature && hasLegacyCookies) {
//       console.log('[XGEN] Legacy cookies detected without signature, clearing cookies.');
//       clearLegacyXgenCookies();
//     } else if (storedSignature && storedSignature !== currentSignature) {
//       console.log('[XGEN] Config changed, clearing legacy cookies.');
//       clearLegacyXgenCookies();
//     }
//     setStoredConfigSignature(currentSignature);
//   };

//   syncCookiesWithCurrentConfig();

//   const initSdk = () => {
//     if (!window.XGenSdkCore?.XGenClient) {
//       setTimeout(initSdk, 50);
//       return;
//     }

//     try {
//       const { XGenClient } = window.XGenSdkCore;
//       window.xgenClient = new XGenClient(config);
//       document.dispatchEvent(new Event('xgen-ready'));
//     } catch (err) {
//       console.error('Init Error:', err);
//     }
//   };

//   initSdk();
// })();